// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2rnOq","buttons":"styles_buttons__2dGFR"};